import { interactedWithRsvpsAnalyticsAction, triggeredSocialShareAnalytics } from './actions';

export enum RsvpAnalyticsActionTypes {
  INTERACTED_WITH_RSVPS = '[Analytics] [Wedding RSVPS] Interacted with RSVPs',
  TRIGGERED_SOCIAL_SHARE = '[Analytics] [Wedding RSVPS] Triggered social share',
}

export type InteractedWithRsvpsAction = ReturnType<typeof interactedWithRsvpsAnalyticsAction>;
export type TriggeredSocialShareAction = ReturnType<typeof triggeredSocialShareAnalytics>;
